import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopMaterialInput,
    DeletePopMaterialInput,
    PopMaterial,
    UpdatePopMaterialInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopMaterialService {
    private amplifyClient = generateClient();
    constructor() {}

    async getPopMaterial(id: string): Promise<PopMaterial> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPopMaterial,
                    variables: {
                        id
                    }
                })
            ).data.getPopMaterial;
            if (data) return data as PopMaterial;
        } catch (error) {
            console.error('Error finding PopMaterial:', error);
            return null;
        }
    }

    async listPopMaterials(): Promise<PopMaterial[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopMaterials
                })
            ).data.listPopMaterials.items;
            if (data) return data as PopMaterial[];
        } catch (error) {
            console.error('Error finding PopMaterial:', error);
            return null;
        }
    }

    async listAllPopMaterials(pageLimit: number = 100): Promise<PopMaterial[]> {
        const materials: PopMaterial[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listPopMaterials,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listPopMaterials;
                materials.push(...((response?.items ?? []) as PopMaterial[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return materials;
        } catch (error) {
            console.error('Error finding PopMaterial:', error);
            return [];
        }
    }

    async createPopMaterial(
        input: CreatePopMaterialInput
    ): Promise<PopMaterial> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopMaterial,
                    variables: {
                        input
                    }
                })
            ).data.createPopMaterial;
            if (date) return date as PopMaterial;
        } catch (error) {
            console.error('Error creating PopMaterial:', error);
            return null;
        }
    }

    async updatePopMaterial(
        input: UpdatePopMaterialInput
    ): Promise<PopMaterial> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopMaterial,
                    variables: {
                        input
                    }
                })
            ).data.updatePopMaterial;
            if (data) return data as PopMaterial;
        } catch (error) {
            console.error('Error updating PopMaterial:', error);
            return null;
        }
    }

    async deletePopMaterial(
        input: DeletePopMaterialInput
    ): Promise<PopMaterial> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePopMaterial,
                    variables: {
                        input
                    }
                })
            ).data.deletePopMaterial;
            if (data) return data as PopMaterial;
        } catch (error) {
            console.error('Error deleting PopMaterial:', error);
            return null;
        }
    }
}
